import { type ReactElement } from 'react';
import { type GetStaticPropsContext } from 'next';
import { getEmptyLayout } from '@/layout';
import { getDefaultStaticProps } from '@/utils';
import { createTranslationAtSSR } from '@/utils/ssr/createTranslationAtSSR';
import { JoinPageView } from './JoinPageView';
export default function JoinPage() {
  return <JoinPageView data-sentry-element="JoinPageView" data-sentry-component="JoinPage" data-sentry-source-file="index.page.tsx" />;
}
JoinPage.getLayout = function (page: ReactElement) {
  return getEmptyLayout(page, true);
};
const getSeoTitle = (t: ReturnType<typeof createTranslationAtSSR>) => {
  return t({
    key: 'seo.join.title'
  });
};
const getSeoDescription = (t: ReturnType<typeof createTranslationAtSSR>) => {
  return t({
    key: 'seo.join.description'
  });
};
export const getStaticProps = async ({
  locale
}: GetStaticPropsContext) => {
  const {
    props: defaultProps
  } = await getDefaultStaticProps({
    locale
  });
  const t = createTranslationAtSSR(defaultProps._nextI18Next, locale || 'en');
  return {
    props: {
      ...defaultProps,
      seoContent: {
        title: getSeoTitle(t),
        description: getSeoDescription(t)
      }
    }
  };
};